import StandingsTestingBase from "./StandingsTestingBase";

export default function StandingsTestingInt() {
    return (
        <StandingsTestingBase
            scopeType="DRIVER"
            classKey="INT"
            heading="Meisterschaftswertung"
            pillLabel="INT"
        />
    );
}
